import React from "react";
import { Navigate } from "react-router-dom";
import { useGlobalContext } from "../context/stateContext";
import { useAuth } from "../context/Auth";

const ProtectedRoutes = ({ component: Component, ...rest }) => {
  const { isAuthenticated, activeSession, isLoadingSession } = useGlobalContext();

  // Show loading state while checking authentication
  if (isLoadingSession) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  if (!activeSession) {
    return <Navigate to="/" />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoutes;